/*! bxs-vue-ui v4.0.1 */
import { k as global_1, _ as _export, N as path } from './es.array.join.js';
import { w as whitespaces, s as stringTrim } from './string-trim.js';

var trim = stringTrim.trim;


var nativeParseInt = global_1.parseInt;
var hex = /^[+-]?0[Xx]/;
var FORCED = nativeParseInt(whitespaces + '08') !== 8 || nativeParseInt(whitespaces + '0x16') !== 22;

// `parseInt` method
// https://tc39.github.io/ecma262/#sec-parseint-string-radix
var _parseInt = FORCED ? function parseInt(string, radix) {
  var S = trim(String(string));
  return nativeParseInt(S, (radix >>> 0) || (hex.test(S) ? 16 : 10));
} : nativeParseInt;

// `parseInt` method
// https://tc39.github.io/ecma262/#sec-parseint-string-radix
_export({ global: true, forced: parseInt != _parseInt }, {
  parseInt: _parseInt
});

var _parseInt$1 = path.parseInt;

var _parseInt$2 = _parseInt$1;

var _parseInt$3 = _parseInt$2;

export { _parseInt$3 as _ };
